import {clsx} from '@gfiber/typesmith';
import {Typography} from '@pixel-party/Typography/v2';

import {useTranslation} from 'react-i18next';

interface DescriptionProps {
  children: React.ReactNode;
  className?: string;
}

export function Description({children, className}: DescriptionProps) {
  return (
    <Typography
      use="body2"
      className={clsx('description', className)}
    >
      {children}
    </Typography>
  );
}

interface FormDescriptionProps {
  children?: React.ReactNode;
  className?: string;
  showRequiredHint?: boolean;
}

export function FormDescription({
  children,
  className,
  showRequiredHint = true,
}: FormDescriptionProps) {
  const {t} = useTranslation();

  return (
    <legend className={className}>
      {children}
      {showRequiredHint && (
        <Description>{t('forms.shared.requiredFieldHint')}</Description>
      )}
    </legend>
  );
}
